import store from '@/store';

export default function loadLayout({ to, next }) {
  store.commit('setLayout', to.meta.layout);
  return next();
}
